module.exports = __webpack_public_path__ + "assets/img/home_cs_5.c1027d43.png";